import { Box, IconButton } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import { styled, useTheme } from '@mui/material/styles';
import { memo, useCallback, useState } from 'react';
import { ICONS } from '@/assets/icons';
import Iconify from '@/components/Iconify';
import { NAVBAR } from '@/config';
import useCollapseDrawer from '@/hooks/useCollapseDrawer';
import useResponsive from '@/hooks/useResponsive';
import { NavBarItems } from '@/layouts/dashboard/navbar/NavBarItems';
import cssStyles from '@/utils/cssStyles';

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

export const NavBarItemsDrawer = memo(function NavBarItemsDrawer() {
  const theme = useTheme();
  const isDesktop = useResponsive('up', 'lg');
  const { isCollapse, collapseHover, onHoverEnter, onHoverLeave } = useCollapseDrawer();

  const [isOpenSidebar, setIsOpenSidebar] = useState(false);
  const onCloseSidebar = useCallback(() => setIsOpenSidebar(false), []);

  return (
    <>
      <Box
        sx={{
          height: '40px',
          position: 'absolute',
          padding: 2,
          display: { xs: 'block', lg: 'none' },
        }}
      >
        <IconButton
          data-cy="cy-navbar-button-open"
          onClick={() => setIsOpenSidebar(true)}
          sx={{ mr: 1, color: 'text.primary' }}
        >
          <Iconify icon={ICONS.EVA_MENU_2_FILL} />
        </IconButton>
      </Box>
      <RootStyle
        sx={{
          position: 'absolute',
          width: {
            lg: isCollapse ? NAVBAR.DASHBOARD_COLLAPSE_WIDTH : NAVBAR.DASHBOARD_WIDTH,
          },
        }}
      >
        {!isDesktop ? (
          <Drawer open={isOpenSidebar} onClose={onCloseSidebar} PaperProps={{ sx: { width: NAVBAR.DASHBOARD_WIDTH } }}>
            <NavBarItems onCloseSidebar={onCloseSidebar} />
          </Drawer>
        ) : null}

        {isDesktop ? (
          <Drawer
            open
            variant="persistent"
            onMouseEnter={onHoverEnter}
            onMouseLeave={onHoverLeave}
            PaperProps={{
              sx: {
                width: NAVBAR.DASHBOARD_WIDTH,
                borderRightStyle: 'solid',
                bgcolor: 'background.default',
                transition: (theme) =>
                  theme.transitions.create(['width', 'box-shadow'], {
                    duration: theme.transitions.duration.shorter,
                  }),
                ...(isCollapse && {
                  width: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
                }),
                ...(collapseHover &&
                  !isCollapse && {
                    ...cssStyles(theme).bgBlur(),
                    boxShadow: (theme) => theme.customShadows.z24,
                  }),
                '&:hover .collapse-button': {
                  opacity: 0.7,
                },
              },
            }}
          >
            <NavBarItems onCloseSidebar={onCloseSidebar} />
          </Drawer>
        ) : null}
      </RootStyle>
    </>
  );
});
